import { render, staticRenderFns } from "./PaginationComponent.vue?vue&type=template&id=390b49fc&"
import script from "./PaginationComponent.vue?vue&type=script&lang=ts&"
export * from "./PaginationComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PaginationComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports